"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _fluxActions = require("flux-actions");

var _immutable = require("immutable");

var ActionTypes = _interopRequireWildcard(require("MeetingsLib/redux/actions/ActionTypes"));

var _handleActions;

var initialState = (0, _immutable.Map)();

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, ActionTypes.MEETING_CREATE_FAILED, function (requestStatus, action) {
  return requestStatus.set('meetingCreate', action.payload.error);
}), (0, _defineProperty2.default)(_handleActions, ActionTypes.PUBLIC_AVAILABILITY_INFO_FETCH_FAILED, function (requestStatus, action) {
  return requestStatus.set('publicAvailabilityInfoFetch', action.payload.error);
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;